var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navigation',{on:{"back-to-first":_vm.backToFirst}}),_c('router-view',{attrs:{"toDepartment":_vm.toDepartment},on:{"back-to-department":_vm.backToDepartment}}),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }